import React from 'react';

import AssistanceLanding from '../components/AssistanceLanding';

class AssistanceLandingPage extends React.Component {
  render() {
    return (
      <div>
        <h2>
          International assistance
        </h2>

        <AssistanceLanding />
      </div>
    );
  }
}

export default AssistanceLandingPage;



// WEBPACK FOOTER //
// ./src/pages/AssistanceLanding.js